<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">Additional Comment</h3>
    </div>
  </div>

  <form class="form" [formGroup]="form">
    <div class="card-body">
      <div class="row">
        <div class="col-12">
          <mat-form-field class="mat-form-field-fluid">
            <textarea matInput formControlName="comment" placeholder="Comment"></textarea>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="card-footer p-0 b-0">
      <div class="form-actions form-actions-solid">
        <div class="row text-right">
          <div class="col-12">
            <button type="button" mat-raised-button (click)="onClose()">
              Close
            </button>&nbsp;
            <button type="button" class="btn btn-success" mat-raised-button color="submit" (click)="onSubmit()">
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>